// /src/components/ApiDropdown.jsx
import React, {useState, useEffect} from 'react'
import Select from 'react-select'
import {getAPIListDropDown} from '../../../../api'

const ApiDropdown = ({
  isDisabled, 
  setSelectedApis, 
  selectedApis,
  selectedEnterprise 
}: {
  isDisabled: boolean
  selectedApis: any[]; 
  selectedEnterprise: number | null;
  setSelectedApis: (apis: any[]) => void
}) => {
  const [apiOptions, setApiOptions] = useState([])
  const [selectedApiData, setSelectedApiData] = useState([]);

  useEffect(() => {
  
    getAPIListDropDown().then((response: any) => {
      if (response.data.unique_apis && Array.isArray(response.data.unique_apis)) {
        const options = response.data.unique_apis.map((api) => ({
          value: api,
          label: api,
        }))
        setApiOptions(options)
      }
    })
  }, [])

  const handleChange = (selected: any) => {
    setSelectedApiData(selected)
    const selectedApiValues = selected.map((api) => api.value)
    setSelectedApis(selectedApiValues)
  }

  useEffect(() => {
    if (!selectedEnterprise) {
      setSelectedApiData([]);
      setSelectedApis([]);
    }
  }, [selectedEnterprise, setSelectedApis]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      width: '200px',
      minHeight: '50px',
      maxHeight: '60px',
      overflowY: 'auto',
      flexWrap: 'wrap',
    }),
    menu: (base) => ({
      ...base,
      width: '200px',
    }),
    multiValue: (base) => ({
      ...base,
    }),
    multiValueLabel: (base) => ({
      ...base,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: 'red',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: '#ffe6e6',
      },
    }),
  }

  return (
    <div style={{display: 'flex', alignItems: 'center', gap: '10px', padding: '10px'}}>
      <Select
        isMulti
        options={apiOptions}
        value={selectedApiData}
        onChange={handleChange}
        isDisabled={isDisabled}
        placeholder='Select APIs...'
        styles={customStyles}
      />
    </div>
  )
}

export default ApiDropdown
